import api from './api';

export const authAPI = {
  // User login
  login: async (email, password, rememberMe = false) => {
    const response = await api.post('/api/appUsers/login', {
      email,
      password,
      ttl: rememberMe ? 1209600 : 3600, // 14 days or 1 hour
    });
    return response;
  },

  // User registration
  register: async (userData) => {
    const response = await api.post('/api/appUsers', {
      username: userData.email, // LoopBack often uses username field
      email: userData.email,
      password: userData.password,
      role: userData.role || 'admin',
    });
    return response;
  },

  // Get current user by ID with access token (with optional additional params)
  getCurrentUser: async (userId, accessToken, extraParams = '') => {
    const baseUrl = `/api/appUsers/${userId}`;
    const queryParams = `access_token=${accessToken}`;
    const fullUrl = extraParams ? `${baseUrl}/${extraParams}?${queryParams}` : `${baseUrl}?${queryParams}`;
    
    const response = await api.get(fullUrl);
    return response;
  },

  // Get current user info using token
  getMe: async () => {
    const response = await api.get('/api/appUsers/me');
    return response;
  },

  // User logout
  logout: async (tokenId) => {
    const response = await api.post(`/api/appUsers/logout?access_token=${tokenId}`);
    return response;
  },

  // Refresh token
  refreshToken: async () => {
    const response = await api.post('/api/appUsers/refresh');
    return response;
  },

  // Forgot password
  forgotPassword: async (email) => {
    const response = await api.post('/api/appUsers/reset', { email });
    return response;
  },

  // Reset password
  resetPassword: async (token, password) => {
    const response = await api.post('/api/appUsers/reset-password', {
      newPassword: password,
      confirmation: password,
    });
    return response;
  },
};